import { AtlasMap } from "@/components/atlas/AtlasMap";
import { JurisdictionPanel } from "@/components/atlas/JurisdictionPanel";

// Combines the interactive map (desktop/tablet) with the sticky detail panel.
// Mobile (<640px) hides the map — the ledger below takes over there.
// Selection and corridor state are owned by the page so the ledger can drive both.
export const AtlasSection = ({ selected, onSelect, dimCorridor }) => (
  <section id="atlas" data-testid="atlas-section" className="bg-[#F6F1E4]">
    <div className="max-w-[1400px] mx-auto">
      <div className="flex flex-col lg:flex-row">
        {/* Map — 62% on desktop, hidden on mobile */}
        <div className="hidden sm:block lg:w-[62%] border-b lg:border-b-0 lg:border-r border-charcoal/10">
          <div className="h-[480px] md:h-[620px]">
            <AtlasMap selected={selected} onSelect={onSelect} dimCorridor={dimCorridor} />
          </div>
        </div>

        {/* Panel — 38% on desktop, sticky */}
        <div className="w-full lg:w-[38%]">
          <div className="lg:sticky lg:top-24">
            <JurisdictionPanel selected={selected} onClear={() => onSelect(null)} />
          </div>
        </div>
      </div>
    </div>
  </section>
);
